export default "__VITE_ASSET__39408735__"